module.exports = __webpack_public_path__ + "img/copy.eabb5c5d.svg";